import React from 'react';
import "./EditIcon.css"

const EditIcon = ({ onClick, disabled = false }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={disabled ? undefined : onClick}  // disable click if disabled
    style={{
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.4 : 1,           // reduced opacity when disabled
      transition: "opacity 0.2s ease"
    }}
  >
    <path
      d="M3.64706 4.5293H2.76471C2.29668 4.5293 1.84782 4.71522 1.51687 5.04617C1.18592 5.37711 1 5.82597 1 6.294V14.2352C1 14.7032 1.18592 15.1521 1.51687 15.483C1.84782 15.814 2.29668 15.9999 2.76471 15.9999H10.7059C11.1739 15.9999 11.6228 15.814 11.9537 15.483C12.2847 15.1521 12.4706 14.7032 12.4706 14.2352V13.3528"
      stroke="#094C80"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5883 2.7648L14.2354 5.41186M15.4575 4.16333C15.805 3.81582 16.0002 3.34449 16.0002 2.85304C16.0002 2.36158 15.805 1.89025 15.4575 1.54274C15.11 1.19523 14.6386 1 14.1472 1C13.6557 1 13.1844 1.19523 12.8369 1.54274L5.41187 8.94128V11.5883H8.05893L15.4575 4.16333Z"
      stroke="#094C80"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
